module.exports = __webpack_public_path__ + "static/img/poster.973d1a42.jpg";